(() => {
  const SELECTOR = '[data-al-library]';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initLibrary = (root) => {
    if (!root || root.dataset.libraryReady === 'true') return;
    root.dataset.libraryReady = 'true';

    const articles = [...root.querySelectorAll('[data-library-article]')];
    const reveals = [...root.querySelectorAll('[data-library-reveal]')];
    const initialTitle = document.title;
    const controller = new AbortController();
    const { signal } = controller;
    let observer;

    const showIndex = () => {
      articles.forEach((article) => article.classList.remove('is-active'));
      root.classList.remove('is-reading');
      document.title = initialTitle;
    };

    const showArticle = (article) => {
      articles.forEach((item) => item.classList.toggle('is-active', item === article));
      root.classList.add('is-reading');
      const title = article.dataset.libraryTitle;
      if (title) document.title = `${title} – Al-Ameer London`;
    };

    const syncFromHash = (shouldScroll = true) => {
      const id = window.location.hash.slice(1);
      const article = articles.find((item) => item.id === id);
      if (article) showArticle(article);
      else showIndex();

      if (shouldScroll) {
        requestAnimationFrame(() => window.scrollTo({
          top: 0,
          behavior: reduceMotion.matches ? 'auto' : 'smooth'
        }));
      }
    };

    const revealCards = () => {
      observer?.disconnect();
      if (reduceMotion.matches || !('IntersectionObserver' in window)) {
        reveals.forEach((item) => item.classList.add('is-visible'));
        return;
      }

      observer = new IntersectionObserver((entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          currentObserver.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });

      reveals.forEach((item) => observer.observe(item));
    };

    window.addEventListener('hashchange', () => syncFromHash(true), { signal });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !root.classList.contains('is-reading')) return;
      window.location.hash = 'library-index';
    }, { signal });
    reduceMotion.addEventListener('change', revealCards, { signal });

    root.classList.add('is-enhanced');
    revealCards();
    syncFromHash(false);

    root.libraryCleanup = () => {
      controller.abort();
      observer?.disconnect();
    };
  };

  const initAll = (scope = document) => scope.querySelectorAll(SELECTOR).forEach(initLibrary);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelector(SELECTOR)?.libraryCleanup?.();
  });
})();
